import {Action} from "@ngrx/store";
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR: string = '[ecommerce performance report net sales last year] Load Ecommerce Performance report net sales Last Year';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_SUCCESS: string = '[ecommerce performance report net sales last year] Load Ecommerce Performance report net sales Last Year Success';
export const LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_FAIL: string = '[ecommerce performance report net sales last year] Load Ecommerce Performance report net sales Last Year Fail';

export class LoadEcommercePerformanceReportNetSalesLastYear implements Action {
  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR;

  constructor(public payload: { websiteId: number, datePicker: string, forceCharge?: boolean }) {
  }
}

export class LoadEcommercePerformanceReportNetSalesLastYearSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_SUCCESS;

  constructor(public payload: {
    netSalesDataLastYear: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePerformanceReportNetSalesLastYearFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_REPORT_NET_SALES_LAST_YEAR_FAIL;

  constructor(public payload: any) {
  }

}


export type EcommercePerformanceReportNetSalesLastYearAction = LoadEcommercePerformanceReportNetSalesLastYear | LoadEcommercePerformanceReportNetSalesLastYearSuccess | LoadEcommercePerformanceReportNetSalesLastYearFail;
